import { Layout } from "antd";
import { Navbar } from "./Navbar";
import styles from "./main-layout.module.css";

export default function MainLayout({ children }) {
    return (
        <Layout className={styles.mainLayout}>
            <Layout.Header className={styles.mainLayoutHeader}>
                <Navbar />
            </Layout.Header>
            <Layout.Content className={styles.mainLayoutContent}>
                <div className='container my-1'>{children}</div>
            </Layout.Content>
        </Layout>
    );
}
